export default __webpack_public_path__ + "static/media/video_bg.a525c194.jpg";